import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { FilterIndicator } from "./FilterIndicator";
import { FilterMappingKey } from "../../../constants";

interface InstallSectionCardProps {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  height?: number;
  noTitleMargin?: boolean;
  filterKey?: FilterMappingKey;
}

export const InstallSectionCard = ({
  title,
  children,
  actions,
  height = 440,
  noTitleMargin = false,
  filterKey,
}: InstallSectionCardProps) => {
  return (
    <Card sx={{ p: 3, height }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={noTitleMargin ? 0 : 5}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h4" fontWeight="bold">
            {title}
          </Typography>
          {filterKey && <FilterIndicator filterKey={filterKey} />}
        </Stack>

        {actions && (
          <Stack direction="row" alignItems="center" spacing={1}>
            {actions}
          </Stack>
        )}
      </Stack>

      <Box height="100%">{children}</Box>
    </Card>
  );
};
